'use strict';

var LiteDatamap = require('./LiteDatamap.js').LiteDatamap;

$(document).ready(function() {
    $('.datatable').DataTable();
    new LiteDatamap({
        "request": {
            "colNames": [
                "Value"
            ],
            "valColumn": "",
            "aggFunc": "",
            "rowNames": [
                "Country Code",
                "Year"
            ]
        },
        "responseCSV": "Country Name,Country Code,Indicator Name,Indicator Code,Year,Value\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2008,4.8\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2009,5.2\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2010,\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2011,3.59368403123194\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2012,\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2013,4.995714\nBrazil,BRA,\"Children in employment, work only (% of children in employment, ages 7-14)\",SL.TLF.0714.WK.ZS,2014,4.45564334085779"
    }, {
	"chartEl": "#datamaps-1",
	"options": {
	    "chart": {
		"margins": {
		    "top": 80,
		    "right": 0,
		    "bottom": 5,
		    "left": 20
		}
	    },
	    "title": {
		"titleText": "Children in employment, work only (% of children in employment, ages 7-14)",
		"titleStyle": "font-size: 24px; font-weight: 700; margin-top: 10px;",
		"subtitleText": "Worldbank Indicator - <b>SL.TLF.0714.WK.ZS</b>",
		"subtitleStyle": "font-size: 14px; color: #777777;",
		"text": "Children in employment, work only (% of children in employment, ages 7-14)",
		"subtext": "Worldbank Indicator - <b>SL.TLF.0714.WK.ZS</b>"
	    },
	    "legend": {
		"breadth": 50,
		"horizPadding": 25,
		"length": "100%",
		"position": "top",
		"type": "auto"
	    },
	    "series": {
		"colorMap": {
		    "scaleType": "colorbrewer",
		    "colorbrewer": "auto",
		    "numColors": 10
		},
		"border": {
		    "borderColor": "#878787",
		    "borderOpacity": 0.5,
		    "borderWidth": 1
		},
		"highlight": {
		    "borderColor": "rgba(250, 15, 160, 0.2)",
		    "borderOpacity": 1,
		    "borderWidth": 2,
		    "enabled": true,
		    "fillColor": "#FCD859",
		    "fillOpacity": 0.2
		}
	    },
	    "tooltip": {
		"excludeFields": "Indicator Name, Indicator Code, Country Name, Country Code",
		"formatStr": '<div style="width:250px;border-radius:1em;padding:10px;background-color:#333;color:#fff;opacity:0.8;grid-gap:10px;"><h5><span style="width:10px;height:10px;background-color:<%= _.get(data, \'fillColor\',\'#fff\')%>;display:inline-block;border-radius:50%;"></span> <%=geo.properties.name%></h5><div style="display:grid;grid-template-columns:auto auto;"><% _.pullAll(_.keys(_.get(data,\'item\')),options.exclude).forEach(function(key){ %><div><%=key%></div><div><%=data.item[key]%></div><% })%><%if(_.get(data,\'item\')){ %><div>Value</div><div><%=options.valueFmt%></div><% }else{ %><i>No data.</i><% } %></div></div>',
		"show": true
	    },
	}
    });
});